const SettingsIcon = (props) => (
    <svg
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M27.3266 15.6267C26.6831 13.8667 24.5808 13.2849 23.1312 14.2482L21.1892 12.6358C21.7141 10.9314 20.4879 9.05655 18.5815 9.00124C16.6182 8.94428 15.2631 10.8558 15.8103 12.6335L13.8669 14.247C12.3731 13.2542 10.2173 13.9132 9.63528 15.7379C9.09767 17.4236 10.2311 19.0757 11.8203 19.3616L12.5722 22.0597C11.2296 23.2157 11.2622 25.4394 12.8347 26.5078C14.3927 27.5662 16.4514 26.8043 17.0569 25.1645H19.9384C20.5658 26.8829 22.7518 27.6021 24.2911 26.4137C25.7736 25.2691 25.6998 23.0935 24.3522 22.0013L25.1284 19.3705C26.7946 19.1049 27.9553 17.3463 27.3266 15.6267M19.8217 23.6178H17.1755C16.8799 22.1648 15.4557 21.1797 13.9948 21.4037L13.3799 19.1971C14.8731 18.5963 15.5304 16.8391 14.8749 15.4205L16.6565 13.9413C17.6958 14.8455 19.2923 14.8567 20.3415 13.9425L22.1247 15.4231C21.4709 16.8377 22.1273 18.5648 23.5725 19.178L22.9195 21.3914C21.4735 21.2109 20.112 22.2069 19.8217 23.6178Z"
            fill="currentColor"
        />
    </svg>
);

export default SettingsIcon;